export const DisableSubmit = (e: any) => {
  e.preventDefault()
  return false
}

export const isFieldArrayDirty = (array) =>
  array?.some((a) => Object.values(a).some((value) => value))
